// API Configuration
export const API_CONFIG = {
  // Use proxy in both dev and production to avoid CORS issues
  BASE_URL: '/api/',
  AI_BASE_URL: '/ai-api/',
  IMAGE_BASE_URL: '/ai-api/',
  API_KEY: 'g78901efgh234ijk3456',
  VITE_STRIPE_PUBLISHABLE_KEY : 'pk_test_FsyuvyOTih6BCHbpzDTq4Gcw',
  TIMEOUT: 30000, // 30 seconds
};
